export { default } from './CapabilityCanvasLayout';
